import React, { Component } from 'react'
import { Text } from 'app/common/typography'
import styled, { css } from 'styled-components'
import { media, style } from 'app/assets/styles'
import { colors } from 'shared/assets/styles'
import type { QuestionShortDTO } from 'shared/types'
import { Chevron, Question as QuestionIcon } from 'app/assets/icons'
import { Link } from 'app/common/link'
import { Collapse } from 'react-collapse'
import type { EventMetadata } from 'shared/store/metadata'
import { eventsDefinitions } from 'shared/store/metadata'
import ReactHtmlParser from 'react-html-parser'

type Props = {
    question: QuestionShortDTO,
    sendMeta: EventMetadata => void
}

type State = {
    collapsed: boolean
}

class QuestionCard extends Component<Props, State> {
    constructor() {
        super()
        this.state = {
            collapsed: false
        }
    }

    collapse = () => {
        const collapsed = !this.state.collapsed
        if (collapsed) {
            const meta = {
                ...eventsDefinitions['FAQ_QUESTIONS'],
                event_label: this.props.question.question
            }
            this.props.sendMeta(meta)
        }
        this.setState({ collapsed })
    }

    render() {
        const {
            actionLabel,
            actionUrl,
            answer,
            external,
            question
        } = this.props.question

        const { collapsed } = this.state
        return (
            <QuestionCardContainer>
                <QuestionCardWrapper onClick={this.collapse}>
                    <Question>
                        <QuestionIcon />
                        <StyledText>
                            <Text>{question}</Text>
                        </StyledText>
                        <Chevron
                            className={collapsed ? 'over' : 'out'}
                            color={colors.text}
                            direction={collapsed ? 'up' : 'down'}
                        />
                    </Question>
                    <Collapse isOpened={collapsed}>
                        <Content hide={!collapsed}>
                            <Answer>
                                <Text color={colors.grey}>
                                    {ReactHtmlParser(answer)}
                                </Text>
                            </Answer>
                            {actionLabel && (
                                <StyledLink
                                    url={actionUrl}
                                    external={external}
                                    border="none"
                                    background={colors.yellow}>
                                    {actionLabel}
                                </StyledLink>
                            )}
                        </Content>
                    </Collapse>
                </QuestionCardWrapper>
            </QuestionCardContainer>
        )
    }
}

const QuestionCardContainer = styled.div`
    display: inline-block;
    width: 100%;
    margin-bottom: 20px;
`

const QuestionCardWrapper = styled.div`
    .ReactCollapse--collapse {
        transition: height 500ms;
    }
    background: ${colors.tertiary};
    padding: 10px 15px;
    cursor: pointer;
    box-sizing: border-box;
    width: 100%;
    border-radius: 10px;
    ${media.medium`
        padding: 25px 30px;
    `};
`

const Question = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 60px;
`
const text = css`
    max-width: 80%;
    ${media.medium`
        width: 85%;
        max-width: 85%;
    `};
    text-align: left;
`
const StyledLink = styled(Link)`
    ${style.buttonMedium};
`
const StyledText = styled.p`
    ${text};
`

const Answer = styled.p`
    margin: 20px auto;
    ${text};
`

const Content = styled.div`
    display: ${props => (props.hide ? 'none' : 'flex')};
    justify-content: center;
    align-items: center;
    flex-direction: column;
`

export { QuestionCard }
